<template>
  <b-row :ref="refName">
    <b-col cols="12" xl="6" class="mb-1">
      <h5 class="mb-0">{{ componentSection.section.title }}<small v-if="componentSection.section.coef" class="text-muted"> | coef : {{
          componentSection.section.coef
        }}% </small></h5>
      <small class="text-muted">{{ componentSection.section.description }}</small>
    </b-col>


    <b-col cols="12" v-if="componentSection.section.position === 1">
      <user-objective-view v-if="userData" :userData="userData"/>
    </b-col>

    <b-col cols="12" v-if="componentSection.section.responseChoice === 'Standard' && componentSection.section.position !== 1">
      <b-card no-body>
        <b-card-body>
          <div v-for="(content, ct) in componentSection.content" :key="ct" :ref="`row_${ct}`">
            <div v-for="(contentSection, ck) in content.contentSections" :key="ck" :ref="`row_${ck}`">

              <b-form-group>
                <template #label>
                  <h6>
                  {{ contentSection.titre }}
                  <span v-if="contentSection.required" class="text-danger">*</span>
                  </h6>

                </template>

                <validation-provider   :key="`provider_${contentSection.idPublic}_${componentSection.section.position}`" #default="{ errors }"
                                     :id="contentSection.idPublic + ' ' + ck + ' ' + componentSection.section.position"
                                       :name="`provider_${contentSection.idPublic}_${componentSection.section.position}`"
                                     :rules="buildValidationRules(contentSection)">
<!--                  :rules="contentSection.required-->
<!--                  ? (contentSection.champsModel.typeReponse === 'double'-->
<!--                  ? 'requiredNotZero|required'-->
<!--                  : 'required')-->
<!--                  : null"-->
<!--                  @input="initForm($event, null, contentSection, componentSection.section.position, false)"-->
                  <component
                      v-if="contentSection.champsModel.type !== 'liste' && contentSection.champsModel.valeur !== 'b-form-tags'"
                      :ref="`field_${contentSection.idPublic}_${componentSection.section.position}`"
                      :is="resolveComponent(contentSection.champsModel.valeur)"
                      :title="contentSection.titre"
                      :description="contentSection.description"
                      :id="`field_${contentSection.idPublic}_${componentSection.section.position}`"
                      v-bind="{ multiple: contentSection.champsModel.autre === 'multiple', switch: contentSection.champsModel.autre === 'switch', inline: contentSection.champsModel.autre === 'inline', disabled: contentSection.readonly === 'readonly' }"
                      v-model="fieldValues[`${contentSection.idPublic}_${componentSection.section.position}`]"
                      :max="contentSection.max !== null ? contentSection.max : undefined"
                      :min="contentSection.max !== null ? 0 : undefined"
                      step="1"
                      :state="contentSection.required && errors.length > 0 ? false : null"
                      :class="{ 'is-invalid': fieldErrors[`field_${contentSection.idPublic}_${componentSection.section.position}`] }"
                      :config="flatPickrConfig"
                      rows="1"
                      max-rows="5"
                      @input="initForm($event, null, contentSection, componentSection.section.position)"
                      class="form-control"
                  />

                  <b-form-tags v-else-if="contentSection.champsModel.valeur === 'b-form-tags'"
                               label="Vous pouvez entrer au maximum 200 caractères et au maximum 3 balises."
                               :id="`field_${contentSection.idPublic}_${componentSection.section.position}`"
                               :ref="`field_${contentSection.idPublic}_${componentSection.section.position}`"
                               v-model="fieldValues[`${contentSection.idPublic}_${componentSection.section.position}`]"
                               no-outer-focus
                               input-id="tags-state-event" :tag-validator="validator"
                               :state="contentSection.required && errors.length > 0 ? false : null"
                               :class="{ 'is-invalid': fieldErrors[`field_${contentSection.idPublic}_${componentSection.section.position}`] }"
                               v-b-popover.hover.top="contentSection.description"
                               @input="initForm($event, null, contentSection, componentSection.section.position, false)">
                    <template v-slot:default="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
                      <b-input-group aria-controls="my-custom-tags-list">
                        <input v-bind="inputAttrs" placeholder="Nouvelle balise - Appuyez sur Entrée pour ajouter"
                               class="form-control" v-on="inputHandlers" @input="onTagTyping(
                                    $event.target.value,
                                    contentSection,
                                    componentSection.section.position
                                  )"
                               :disabled="tags.length >= contentSection.max"/>
                        <b-input-group-append>
                          <b-button variant="primary" @click="tags.length < contentSection.max && addTag()">
                            Ajouter
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <p v-if="tags.length >= contentSection.max" class="text-danger mt-2">
                        Vous avez atteint le maximum de {{ contentSection.max }} Entrée.
                      </p>
<!--                      <p v-if="!showLengthWarning" class="text-danger mt-2">-->
<!--                        Vous pouvez entrer au maximum 200 caractères. </p>-->

                      <p
                          v-if="liveTagErrors[`${contentSection.idPublic}_${componentSection.section.position}`]"
                          class="text-danger mt-2"
                      >
                        {{ liveTagErrors[`${contentSection.idPublic}_${componentSection.section.position}`] }}
                      </p>
<!--                      d-inline-flex flex-wrap-->
                      <li
                          v-for="(tag, index) in tags"
                          :key="tag"
                          class="d-flex align-items-center border rounded px-2 py-1 mb-1"
                      >
                                <span class="font-weight-bold mr-2">
                                  {{ index + 1 }}.
                                </span>

                        <span class="flex-grow-1">
                                {{ tag }}
                              </span>

                        <b-button
                            variant="link"
                            size="sm"
                            class="py-0"
                            @click="removeTag(tag)"
                        >
                          Supprimer
                        </b-button>
                      </li>

<!--                      <ul id="my-custom-tags-list" class="list-unstyled mb-0" aria-live="polite"-->
<!--                          aria-atomic="false" aria-relevant="additions removals">-->

<!--                        <b-card v-for="tag in tags" :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`" :key="tag"-->
<!--                                tag="li" class="shadow-none border mt-1 mr-1 mb-0" body-class="py-1 pr-2 text-nowrap">-->
<!--                          <strong>{{ tag }}</strong>-->
<!--                          <b-button variant="link" size="sm"-->
<!--                                    :aria-controls="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`" class="py-0"-->
<!--                                    @click="removeTag(tag)">-->
<!--                            Supprimer-->
<!--                          </b-button>-->
<!--                        </b-card>-->
<!--                      </ul>-->
                    </template>
                  </b-form-tags>

                  <component
                      v-else-if="contentSection.champsModel.type === 'liste' && contentSection.champsModel.valeur !== 'b-form-tags'"
                      :is="resolveComponent(contentSection.champsModel.valeur)" :title="contentSection.titre"
                      :id="`field_${contentSection.idPublic}_${componentSection.section.position}`"
                      :ref="`field_${contentSection.idPublic}_${componentSection.section.position}`"
                      :description="contentSection.description"
                      :options="processValueList(contentSection.valueList, null)"
                      class="demo-inline-spacing"
                      v-model="fieldValues[`${contentSection.idPublic}_${componentSection.section.position}`]"
                      :state="contentSection.required && errors.length > 0 ? false : null"
                      :class="{ 'is-invalid': fieldErrors[`field_${contentSection.idPublic}_${componentSection.section.position}`] }"
                      v-bind="{ multiple: contentSection.champsModel.autre === 'multiple', switch: contentSection.champsModel.autre === 'switch', inline: contentSection.champsModel.autre === 'inline', disabled: contentSection.readonly === 'readonly' }"
                      @input="initForm($event, null, contentSection, componentSection.section.position, false)"/>
<!--                  <small class="text-danger">{{-->
<!--                      errors[0] ? `Le champ "${contentSection.titre}" est requis.` : ""-->
<!--                    }}</small>-->
<!--                  <small class="text-danger">-->
<!--                    {{ errors[0] }}-->
<!--                  </small>-->
<!--                  ? errors[0].includes('required') ? `Le champ "${contentSection.titre}" est requis.` : errors[0]  : ""-->
                  <small class="text-danger">
                    {{
                      fieldErrors[`field_${contentSection.idPublic}_${componentSection.section.position}`]
                      || (errors[0] )
                    }}
                  </small>
                </validation-provider>

                <b-popover v-b-popover.hover.top
                           :target="`field_${contentSection.idPublic}_${componentSection.section.position}`"
                           placement="top"
                           triggers="hover" v-if="contentSection.description">
                  <template #title>
                    {{ contentSection.titre }}
                  </template>
                  <template #default>
                    <div v-if="Array.isArray(convertedDescription(contentSection.description))">
                    <span>
                      <li v-for="(point, index) in convertedDescription(contentSection.description)"
                          :key="'point-' + index">
                        {{ point }}
                      </li>
                    </span>
                    </div>

                    <div v-else>
                      <span>{{ convertedDescription(contentSection.description) }}</span>
                    </div>
                  </template>
                </b-popover>


              </b-form-group>
            </div>
            <hr>

          </div>

        </b-card-body>

      </b-card>
    </b-col>

    <b-col cols="12" v-else>
      <b-card no-body>
        <b-card-body>
          <div v-for="(content, contentk) in componentSection.content" :key="contentk" :ref="`row_${contentk}`">
            <div v-for="componentsTable in content.componentModels" :key="componentsTable.position">
              <b-card-header class="pb-30 px-0">

                <b-col xl="12" cols="12">

                  <h5 class="title-with-icon text-primary font-weight-bold">
                    {{ componentsTable.titre }}

                    <feather-icon
                        v-if="componentsTable.description"
                        icon="InfoIcon"
                        size="14"
                        class="info-icon"
                        v-b-popover.hover.left.html="componentsTable.description"
                        title="Description"
                    />

                    <feather-icon
                        v-else-if="componentsTable.indicateur"
                        icon="InfoIcon"
                        size="14"
                        class="info-icon"
                        v-b-popover.hover.left.html="componentsTable.indicateur"
                        title="Indicateur"
                    />
                  </h5>

                  <h6 v-if="componentsTable.note" class="text-muted">coef : {{ componentsTable.note }}% </h6>

                </b-col>


              </b-card-header>
              <b-row class="mx-0">
                <b-col v-for="contentSection in content.contentSections" :key="contentSection.position"
                       :cols="contentSection.taille" :xl="contentSection.taille"  >
                  <div class="px-1">

                  <b-form-group>
                    <template #label>
                      <h6>
                      {{
                        contentSection.max ? `${contentSection.titre} sur
                      ${contentSection.max}` : `${contentSection.titre}`
                      }}
                        <span v-if="contentSection.required" class="text-danger">*</span>
                      </h6>
                    </template>
                    <validation-provider :key="`provider_${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`" #default="{ errors }"
                                         :name="`provider_${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`"
                                         :rules="buildValidationRules(contentSection)"
                    >
<!--                      contentSection.titre-->

                      <component
                          v-if="contentSection.champsModel.type !== 'liste' && contentSection.champsModel.valeur !== 'b-form-tags' && contentSection.champsModel.valeur !== 'flat-pickr'"
                          :ref="`field_${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`"
                          :is="resolveComponent(contentSection.champsModel.valeur)" :title="contentSection.titre"
                          :description="contentSection.description"
                          :id="`field_${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`"
                          v-bind="{ multiple: contentSection.champsModel.autre === 'multiple', switch: contentSection.champsModel.autre === 'switch', inline: contentSection.champsModel.autre === 'inline', disabled: contentSection.readonly === 'readonly' }"
                          v-model="fieldValues[`${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`]"
                          :max=" contentSection.max !== null ? contentSection.max : undefined"
                          :min="contentSection.max !== null ? 0 : undefined" :step="1"
                          rows="1"
                          max-rows="5"
                          :state="errors.length > 0 ? false : null"
                          :class="{ 'is-invalid': fieldErrors[`field_${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`] }"
                          @input="initForm($event, componentsTable, contentSection, componentSection.section.position, false)"/>

                      <b-form-tags v-else-if="contentSection.champsModel.valeur === 'b-form-tags'"
                                   label="Vous pouvez entrer au maximum 200 caractères et au maximum 3 balises."
                                   :id="`field_${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`"
                                   v-model="fieldValues[`${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`]"
                                   no-outer-focus input-id="tags-state-event" :tag-validator="validator"
                                   :state="contentSection.required && errors.length > 0 ? false : null"
                                   v-b-popover.hover.top="contentSection.description"
                                   :class="{ 'is-invalid': fieldErrors[`field_${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`] }"
                                   @input="initForm($event, componentsTable, contentSection, componentSection.section.position, false)">
                        <template v-slot:default="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
                          <b-input-group aria-controls="my-custom-tags-list">
                            <input v-bind="inputAttrs" placeholder="Nouvelle balise - Appuyez sur Entrée pour ajouter"
                                   class="form-control" v-on="inputHandlers"
                                   @input="onTagTyping(
                                    $event.target.value,
                                    contentSection,
                                    componentSection.section.position,
                                    componentsTable
                                  )"
                                   :disabled="tags.length >= contentSection.max"/>
                            <b-input-group-append>
                              <b-button variant="primary" @click="tags.length < contentSection.max && addTag()">
                                Ajouter
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                          <p v-if="tags.length >= contentSection.max" class="text-danger mt-2">
                            Vous avez atteint le maximum de 3 Entrée.
                          </p>
<!--                          <p v-if="duplicateError" class="text-danger mt-2">{{ duplicateError }}</p>-->

<!--                          <p v-if="!showLengthWarning" class="text-danger mt-2">-->
<!--                            Vous pouvez entrer au maximum 200 caractères. </p>-->

<!--                          <p v-if="!validateInput" class="text-danger mt-2">-->
<!--                            Le texte ne doit pas contenir de code HTML ou JavaScript. </p>-->
                          <p
                              v-if="liveTagErrors[`${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`]"
                              class="text-danger mt-2"
                          >
                            {{ liveTagErrors[`${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`] }}
                          </p>
<!--                          class="list-unstyled d-inline-flex flex-wrap mb-0"-->
                          <ul id="my-custom-tags-list"
                              class="list-unstyled mb-0"
                              aria-live="polite" aria-atomic="false" aria-relevant="additions removals">

                            <li
                                v-for="(tag, index) in tags"
                                :key="tag"
                                class="d-flex align-items-center border rounded px-2 py-1 mb-1"
                            >
                                <span class="font-weight-bold mr-2">
                                  {{ index + 1 }}.
                                </span>

                              <span class="flex-grow-1">
                                {{ tag }}
                              </span>

                              <b-button
                                  variant="link"
                                  size="sm"
                                  class="py-0 text-danger"
                                  @click="removeTag(tag)"
                              >
                                Supprimer
                              </b-button>
                            </li>

<!--                            <b-card v-for="tag in tags" :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"-->
<!--                                    :key="tag" tag="li" class="shadow-none border mt-1 mr-1 mb-0"-->
<!--                                    body-class="py-1 pr-2 text-nowrap">-->
<!--                              <strong>{{ tag }}</strong>-->
<!--                              <b-button variant="link" size="sm"-->
<!--                                        :aria-controls="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`" class="py-0"-->
<!--                                        @click="removeTag(tag)">-->
<!--                                Supprimer-->
<!--                              </b-button>-->
<!--                            </b-card>-->
                          </ul>
                        </template>
                      </b-form-tags>


                      <flat-pickr v-else-if="contentSection.champsModel.valeur === 'flat-pickr'"
                                  v-model="fieldValues[`${contentSection.idPublic}_${componentSection.section.position}`]"
                                  class="form-control"
                                  :config="flatPickrConfig"
                                  @on-change="initForm($event, null, contentSection, componentSection.section.position, false)" />

                      <component
                          v-else-if="contentSection.champsModel.type === 'liste' && contentSection.champsModel.valeur !== 'b-form-tags'"
                          :is="resolveComponent(contentSection.champsModel.valeur)" :title="contentSection.titre"
                          :id="`field_${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`"
                          :ref="`field_${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`"
                          :description="contentSection.description"
                          :options="processValueList(contentSection.valueList, null)" class="demo-inline-spacing"
                          v-model="fieldValues[`${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`]"
                          v-bind="{ multiple: contentSection.champsModel.autre === 'multiple', switch: contentSection.champsModel.autre === 'switch', inline: contentSection.champsModel.autre === 'inline', disabled: contentSection.readonly === 'readonly' }"
                          :state="errors.length > 0 ? false : null"
                          :class="{ 'is-invalid': fieldErrors[`field_${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`] }"
                          @input="initForm($event, componentsTable, contentSection, componentSection.section.position, false)"/>


<!--                      <small class="text-danger"                          :state="contentSection.required && errors.length > 0 ? false : null"
>-->
<!--                        {{-->
<!--                          errors[0] ? errors[0].includes('required') ? `Le champ "${contentSection.titre}" est requis.` : errors[0]  : ""-->
<!--                        }}-->
<!--                      </small>-->

                      <small class="text-danger">
                        {{
                          fieldErrors[`field_${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`]
                          || (errors[0] ? errors[0].includes('required') ? `Le champ "${contentSection.titre}" est requis.` : errors[0]  : "")
                        }}
                      </small>


                    </validation-provider>

                    <b-popover v-b-popover.hover.top
                               :target="`field_${contentSection.idPublic}_${componentsTable.idPublic}_${componentSection.section.position}`"
                               placement="top" triggers="hover" v-if="contentSection.description">
                      <template #title>
                        {{ contentSection.titre ? contentSection.titre : componentsTable.titre }}
                      </template>
                      <template #default>
                        <div v-if="Array.isArray(convertedDescription(contentSection.description))">
                          <span>
                            <li v-for="(point, index) in convertedDescription(contentSection.description)"
                                :key="'point-' + index">
                              {{ point }}
                            </li>
                          </span>
                        </div>

                        <div v-else>
                          <span>{{ convertedDescription(contentSection.description) }}</span>
                        </div>
                      </template>
                    </b-popover>


                  </b-form-group>
                  </div>


                </b-col>

              </b-row>

            </div>
            <hr>

          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BCol,
  BFormGroup,
  BFormTags,
  BInputGroup,
  BInputGroupAppend,
  BPopover,
  BRow,
  VBPopover
} from 'bootstrap-vue';
import UserObjectiveView from '@/views/objectif/UserObjectiveView.vue';
import {required} from '@validations'
import {extend, ValidationProvider} from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import NumericInput from '@/util/NumericInput.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/themes/material_blue.css'
import { French } from 'flatpickr/dist/l10n/fr.js'
import moment from "moment/moment";


// Code pour mettre en français le message d'erreur required
extend('required', {
  validate(value) {
    if (Array.isArray(value)) {
      return value.length > 0; // pour b-form-tags
    }
    return !!value && value.toString().trim() !== '';
  },
  message: 'Le champ est requis.',

  // message: (fieldName) => `Le champ « ${fieldName} » est requis.`,
});
const forbiddenPatterns = [
  /<\s*\/?\s*[a-zA-Z][a-zA-Z0-9_-]*\s*.*?>/i,
  /<\s*script/i,
  /<\s*style/i,
  /on\w+\s*=/i,
  /(javascript|data|vbscript):/i,
  /(\$\{[^}]*\}|\{\{[^}]*\}\}|#\{[^}]*\})/,
  /(%3C|%3E|&#\d+;|&#x[0-9a-fA-F]+;|\\u[0-9a-fA-F]{4}|\\x[0-9a-fA-F]{2})/i,
  /<!--|-->/
];

extend('noHtmlCode', {
  validate: (value) => {
    if (!value) return true; // vide ok
    // Vérifie chaque pattern du tableau
    for (const pattern of forbiddenPatterns) {
      if (pattern.test(value)) {
        return false; // interdit si un pattern match
      }
    }
    return true; // tout est ok
  },
  message: 'Le texte ne doit pas contenir de code HTML ou JavaScript.',
});



extend('requiredNotZero', {
  validate(value) {
    return !(value === 0 || value === '0' || value === '0.0' || value === null || value === undefined || value === '');

  },
  message: 'Ce champ est requis et ne peut pas être égal à 0.'
})


export default {
  components: {
    BRow,
    VBPopover,
    BCol,
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BFormGroup,
    BFormTags,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    NumericInput,
    UserObjectiveView,
    ValidationProvider,
    BPopover,
    flatPickr,
  },
  data() {
    return {
      // fieldValues: {},
      required,
      showLengthWarning: true,
      duplicateError: null,
      // newIndex,
      previousIndex: null,
      inlineDate:null,
      validateInput:true,
      liveTagErrors: {},

    };
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  props: {


    componentSection: {
      type: Object,
      required: true,
      default: () => ({})
    },
    userEvaluation: {
      type: Object,
      required: true,
      default: () => ({})

    },
    fieldValues: {
      type: Object,
      required: true,
      default: () => ({})

    },
    fieldErrors: {
      type: Object,
      required: true,
      default: () => ({})
    },
    initForm: {
      type: Function,
      required: true,
    },
    findResponse: {
      type: Function,
      required: true,
    },
    sumFields: {
      type: Array,
      required: true,
      default: () => ([])

    },
    isHierarchyModifying: {
      type: Function,
      required: true,
    },
    userData: {
      type: Object,
      required: true,
      default: () => ({})

    },
    processValueList: {
      type: Function,
      required: true,
    },
    isChange: {
      type: Number,
      required: true,
    },
    refName: {
      type: String,
      required: true
    },
    position: {
      type: Number,
    },
    config: {
      type: Number,
    },
    evaluationStartDate:{
      type: String,
    },
  },
  computed: {
    French() {
      return French
    },
    flatPickrConfig() {
      const today = new Date();

      let minDate = this.evaluationStartDate
          ? moment(this.evaluationStartDate, "DD-MM-YYYY").hour(8).minute(0).second(0).millisecond(0).toDate()
          : today;

      const daysToAdd = this.config;
      let maxDate = this.addBusinessDays(minDate, daysToAdd);

      if (minDate < today) {
        minDate = today;
      }

      const MIN_BUSINESS_DAYS = 5;

      const datePropose = this.userEvaluation?.dateEvaluationPropose
          ? moment(this.userEvaluation.dateEvaluationPropose, "DD-MM-YYYY HH:mm").toDate()
          : this.userEvaluation?.dateEvaluationPrevu
              ? moment(this.userEvaluation.dateEvaluationPrevu, "DD-MM-YYYY HH:mm").toDate()
              : null;

      if (datePropose && datePropose < minDate) {
        minDate = today;
      }


      if (maxDate <= minDate) {
        maxDate = this.addBusinessDays(minDate, MIN_BUSINESS_DAYS);

      } else {
        const businessDaysLeft = this.countBusinessDays(minDate, maxDate);

        if (businessDaysLeft < MIN_BUSINESS_DAYS) {
          maxDate = this.addBusinessDays(maxDate, MIN_BUSINESS_DAYS);
        }
      }
      return {
        enableTime: true,
        time_24hr: true,
        enableSeconds: false,
        inline: true,
        altInput: true,
        altFormat: "d-m-Y H:i",
        dateFormat: "d-m-Y H:i",
        minDate: today,
        maxDate,
        locale: French,
        disable: [
          function (date) {
            const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());

            if (d.getDay() === 0 || d.getDay() === 6) {
              return true;
            }

            if (datePropose && moment(date).isSame(datePropose, 'minute')) {
              return false;
            }

            return d < t;
          }
        ]
      };
    }


  },
  watch: {
    isChange(newVal, oldVal) {
      if (newVal === this.position) {

        this.componentSection.content.forEach(content => {
          content.contentSections?.forEach(contentSection => {
            if (contentSection.somme) {
              if (content.section.responseChoice === 'Standard') {
                this.initForm(0, null, contentSection, this.componentSection.section.idPublic, false);

              } else {
                if (content.componentModels?.length) {
                  content.componentModels.forEach(componentsTable => {
                    this.initForm(0, componentsTable, contentSection, this.componentSection.section.position, false);
                  });
                }
              }
            }
          });
        });
        // this.$emit("auto-save-evaluation", this.userEvaluation);

        this.$emit("update-next-button", this.componentSection.section.position);


      }

    }
  },
  methods: {
    onTagTyping(value, contentSection, sectionPosition, componentsTable = null) {
      const key = componentsTable
          ? `${contentSection.idPublic}_${componentsTable.idPublic}_${sectionPosition}`
          : `${contentSection.idPublic}_${sectionPosition}`;

      // Reset erreur du champ courant
      this.$set(this.liveTagErrors, key, null);

      if (!value) return;

      if (value.length > 200) {
        this.$set(this.liveTagErrors, key, 'Vous pouvez entrer au maximum 200 caractères.');
        return;
      }

      const forbidden = /<[^>]*>|<script\b|on\w+\s*=|javascript:|[<>]/i;
      if (forbidden.test(value)) {
        this.$set(
            this.liveTagErrors,
            key,
            'Le texte ne doit pas contenir de code HTML ou JavaScript.'
        );
        return;
      }

      const existingTags = this.fieldValues[key] || [];
      if (existingTags.includes(value.trim())) {
        this.$set(
            this.liveTagErrors,
            key,
            `⚠️ Le point "${value}" existe déjà.`
        );
      }
    }
    ,



    buildValidationRules(contentSection) {
      let rules = [];
      if (contentSection.required) {
        if (contentSection.champsModel.typeReponse === 'double') {
          rules.push('requiredNotZero');
        } else {
          rules.push('required');
        }
        // if (contentSection.champsModel.typeReponse === 'double') rules.push('requiredNotZero', 'required');
        // else rules.push('required');
      }
      const textFields = ['string', 'list'];
      if (textFields.includes(contentSection.champsModel.typeReponse)) rules.push('noHtmlCode');
      return rules.length ? rules.join('|') : null;
    },
    countBusinessDays(start, end) {
      let count = 0;
      const date = new Date(start);

      while (date < end) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (day !== 0 && day !== 6) {
          count++;
        }
      }
      return count;
    },
    addBusinessDays(today, daysToAdd) {
      const date = new Date(today);
      let addedDays = 0;

      if (date.getDay() !== 0 && date.getDay() !== 6) {
        addedDays = 1;
      }

      while (addedDays < daysToAdd) {
        date.setDate(date.getDate() + 1);

        const day = date.getDay();
        if (day !== 0 && day !== 6) {
          addedDays++;
        }
      }

      return date;
    },

    convertedDescription(description) {
      if (description) {
        if (description.includes('•')) {


          return description
              .split('•')
              .map(point => point.trim())
              .filter(point => point !== "");
        } else {
          return description;
        }
      }
      return [];
    },
    validator(tag) {
      if (!tag) return true;

      if (tag.length > 200) return false;

      const forbidden = /<[^>]*>|<script\b|on\w+\s*=|javascript:|[<>]/i;
      if (forbidden.test(tag)) return false;

      const key = `${this.contentSection?.idPublic}_${this.componentSection?.section?.position}`;
      const existingTags = this.fieldValues[key] || [];

      return !existingTags.includes(tag.trim());
    },

    resolveComponent(componentValue) {
      return componentValue || 'b-form-textarea';
    },


  },
};
</script>
<style>
.title-with-icon {
  display: inline-flex;
  align-items: flex-start;
}

.info-icon {
  margin-left: 6px;
  margin-top: 2px;
  cursor: pointer;
}

</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
